import { CheckBox } from "designSystem/Checkbox";
import React from "react";
import { createUseStyles } from "react-jss";
import { getDeclination } from "Utils/text";

const getPriceText = (price, text) => {
	return getDeclination(price, text.rubles_1, text.rubles_2, text.rubles_3);
};

const getChannelDeclination = (channels, text) => {
	return getDeclination(
		channels,
		text.CHANNELS_DECLINATION.ONE,
		text.CHANNELS_DECLINATION.TWO,
		text.CHANNELS_DECLINATION.FIVE
	);
};

const useStyles = createUseStyles((theme) => ({
	value: {
		color: theme.palette.colors.purplishBlue,
	},
}));

export const AdditionalServiceCheckbox = ({
	checked,
	onChange,
	convergentCost,
	text,
	channels,
	speed,
}) => {
	const classes = useStyles();

	const label =
		convergentCost > 0 ? (
			<>
				{text.WANT_PROVIDER_CONVERGENT.CONVERGENT_MORE.BASE}
				{channels && text.WANT_PROVIDER_CONVERGENT.AND_TV}
				<span className={classes.value}>
					{speed} {text.MB_PER_SECOND}
				</span>{" "}
				{channels && (
					<>
						{text.WANT_PROVIDER_CONVERGENT.AND_TV}
						<span className={classes.value}>
							{channels} {getChannelDeclination(channels, text)}
						</span>{" "}
					</>
				)}
				{text.WANT_PROVIDER_CONVERGENT.CONVERGENT_MORE.FOR} {convergentCost}{" "}
				{getPriceText(convergentCost, text)}
			</>
		) : (
			<>
				{text.WANT_PROVIDER_CONVERGENT.CONVERGENT_LESS.BASE}
				{channels && text.WANT_PROVIDER_CONVERGENT.AND_TV}
				{text.WANT_PROVIDER_CONVERGENT.CONVERGENT_LESS.TARIFF}
				{convergentCost === 0 ? (
					<span className={classes.value}>{text.WANT_PROVIDER_CONVERGENT.FREE}</span>
				) : (
					<>
						{text.WANT_PROVIDER_CONVERGENT.CONVERGENT_LESS.PRICE}
						<span className={classes.value}>{Math.abs(convergentCost)}</span>{" "}
						{getPriceText(convergentCost, text)}
					</>
				)}
			</>
		);

	return <CheckBox checked={checked} onChange={onChange} label={label} />;
};
